import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { CORE_PRICE, SALE_PRICE } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        setVisible(window.scrollY > 700);
      });
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-white/[0.08] bg-steel-950/95 px-6 py-3 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'invisible pointer-events-none translate-y-4 opacity-0'}`} data-id="element-188" data-mp="3gje4r36yzp97">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4" data-id="element-189" data-mp="gz0ekve6qasz">
        <p className="hidden font-display text-sm font-semibold uppercase tracking-[0.16em] text-ink-400 sm:block" data-id="element-190" data-mp="76nogq7n8r13">
          IIIS 2026 · <span className="text-ink-50" data-id="element-191" data-mp="24pyze8ngzzp">${SALE_PRICE}</span>{' '}
          <span className="line-through" data-id="element-192" data-mp="gwgznq3vj44t">${CORE_PRICE}</span>
        </p>
        <CtaButton href={CHECKOUT_URL} size="md" label="Get The System" className="w-full sm:w-auto" data-id="element-193" data-mp="c4gr599qn2wm" />
      </div>
    </div>;
}